import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import FieldInfo from './FieldInfo'
import { getActiveCommunity } from '../../utility/activeCommunity'

const ActiveCommunityNotice = () => {
  const { t } = useTranslation()
  const currentUser = useSelector(state => state.user.current_user)
  const activeCommunityId = useSelector(state => state.user.active_community_id)

  const activeCommunity = getActiveCommunity(currentUser, activeCommunityId)

  if ((currentUser?.communities || []).length < 2 || !activeCommunity) {
    return null
  }

  return <FieldInfo message={t('common.activeCommunityNotice', { community: activeCommunity.name })} />
}

export default ActiveCommunityNotice
